module.exports = __webpack_public_path__ + "static/media/home_logo.13ed7f32.png";